import { Button, SidebarMenuItem, useSidebar } from '@duck/ui'
import { useAuth } from '@/hooks/useAuth'

const loginsEnv = localStorage.getItem('quickLogins')

// localStorage.setItem('quickLogins', '[Name](e@ma.il|PASSWORD),[...')

export const QuickLoginButtons = () => {
    const { signInWithEmail, isSigningInWithEmail, signOut, isAuthenticated } = useAuth()
    const { open } = useSidebar()

    if (!loginsEnv) {
        return null
    }

    const entries = loginsEnv
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
        .map((item) => {
            const match = item.match(/^\[([^\]]+)\]\(([^)]+)\)$/)
            if (!match) return null
            const [, label, credentials] = match
            const [email, explicitPassword] = credentials.split('|')
            if (!email) return null
            return { label, email, password: explicitPassword || email }
        })
        .filter((entry): entry is { label: string; email: string; password: string } => Boolean(entry))

    if (entries.length === 0) {
        return null
    }

    const handleQuickLogin = async (email: string, password: string) => {
        if (isAuthenticated) {
            await signOut()
        }
        void signInWithEmail({
            email,
            password,
        })
    }

    return (
        <SidebarMenuItem>
            <div className="px-2 mt-2 flex flex-wrap gap-2">
                {entries.map(({ label, email, password }) => (
                    <Button
                        key={email}
                        size="xs"
                        variant="outline"
                        onClick={() => handleQuickLogin(email, password)}
                        disabled={isSigningInWithEmail}
                    >
                        {open ? label : label.charAt(0)}
                    </Button>
                ))}
            </div>
        </SidebarMenuItem>
    )
}
